import * as R from 'ramda';
import * as types from '../types';
import { SET_MAIN_NAV_ACTIVE } from '../../../../store/app/types';
import { setMainNavInactive } from '../../../../store/app/mutations';
import router from '../../../../router';
import { getNavTabModule } from '../../../../dt-plugins/sidewindow/nav-tab';
import { bookingTemplatesService } from '../../services/booking-templates.service';

const NavTabModule = getNavTabModule(types.TemplateDetails, 'templateDetails');
const booking_template_id = () => router.currentRoute.params.booking_template_id;

export const templateActions = {
  async [types.SelectedBookingTemplate.FETCH.SINGLE]({ commit, getters }, { flag, template }) {

    // console.log('Fetch Template Details')
    // commit(types.SelectedBookingTemplate.SET.SINGLE, template);

    // template = {booking_template_id};
    setMainNavInactive(commit, flag);
  },
  ...NavTabModule.implementActions(
    'booking_template_id',
    'templates/booking_template_id/tab',
    'templates',
    () => router,
    'booking',
    (value, key) => {
      return {
        title: value?.bookingTemplate?.booking_template_name ? value?.bookingTemplate?.booking_template_name : key,
        full_title: value?.bookingTemplate?.booking_template_name ? value?.bookingTemplate?.booking_template_name : key
      }
    }
  ),

  // Show Sidewindow
  async [types.TemplateDetails.FETCH.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    let { flag, bookingTemplate, reload } = payload;

    flag = typeof flag === "boolean" ? flag : true;

    setMainNavInactive(commit, flag);

    const primaryKey = "booking_template_id";
    const itemName = "bookingTemplate";
    const item = payload[itemName];

    if (!item) {
      return;
    }

    const primaryKeyValue = item[primaryKey];
    const detailsGetterKey = "templateDetails";

    // Check Reload and prexisting Item Logic
    if (getters?.[detailsGetterKey]?.[primaryKeyValue] && !reload) {
      return;
    }

    NavTabHelper.setSingleNavTabDetails(primaryKeyValue, () => {
      return {
        [itemName]: item,
        loading: true
      };
    });

    // HTTP Req
    const detailsData = await bookingTemplatesService.getBookingTemplate(primaryKeyValue);

    NavTabHelper.setSingleNavTabDetails(
      primaryKeyValue,
      (detailsDict, bookingTemplate) => {
        return {
          ...bookingTemplate,
          ...detailsData.data,
          loading: false,
        };
      }
    );
  },
  async [types.TemplateDetails.UPDATE.MULTIPLE]({ dispatch, getters }, payload) {
    const { booking_template_id, ...rest } = payload;
    const tempID = booking_template_id ? booking_template_id : booking_template_id();

    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    NavTabHelper.updateSingleNavTabDetails(tempID, templateDetailsObj => {
      return {
        ...templateDetailsObj,
        ...rest
      };
    });
  },
  async [types.TemplateDetails.UPDATE.SINGLE]({ dispatch, commit, getters }, payload) {

    const { name, value, item } = payload;

    // console.log(payload);

    const key = 'booking_template_id';
    const table = 'booking_locations';
    const kVal = item[key];

    const updatedPayload = {
      booking_template_id: kVal,
      bookingTemplate: {
        ...(getters.templateDetails[kVal]).bookingTemplate,
        [name]: value
      }
    };
    dispatch(types.TemplateDetails.UPDATE.MULTIPLE, updatedPayload);

    const isRecord = !['booking_template_name', 'subject', 'type'].includes(name);
    await bookingTemplatesService.modify({ isRecord, name, value, kVal });
  },
}